import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '@eai-tdv/environment';

import { AppModule } from './app/app.module';

/** hide all console logs for production with real clients */
export function initConsoleLogsVisibility(): void {
  if (environment.production && environment.type === 'prod') {
    window.console.log = (): void => {
      //
    };
    window.console.error = (): void => {
      //
    };
  }
}

initConsoleLogsVisibility();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    console.error('MAIN ERROR CATCH', err);
  });
